// Remembers the active chat conversation id across page loads (localStorage),
// so a refresh doesn't strand the user in a brand-new conversation. Matches
// the server's 24h ChatConversation TTL — an id read back after that window
// just 404s once and gets dropped (see ChatContext's hydrate effect).

const CONVERSATION_ID_KEY = 'ss-v2-chat-conversation-id';

export function readConversationId() {
  try {
    return window.localStorage.getItem(CONVERSATION_ID_KEY) || null;
  } catch {
    return null;
  }
}

export function writeConversationId(id) {
  try {
    window.localStorage.setItem(CONVERSATION_ID_KEY, id);
  } catch {
    /* storage unavailable — non-fatal */
  }
}

export function clearConversationId() {
  try {
    window.localStorage.removeItem(CONVERSATION_ID_KEY);
  } catch {
    /* non-fatal */
  }
}
